module.exports = __webpack_public_path__ + "static/media/Leah Gayheart Headshot.c7aeaefa.png";